import { PayloadViewer } from './PayloadViewer';

export function JsonBlock({ value }: { value: unknown }) {
  return <PayloadViewer value={value} className="code-block" />;
}
